import { DataLogin } from './../servicios/autenticacion.service';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));
    
    let request = req;
    
    if (loginData) {
      const headers: any = {
        cli: 'PAdmon',
        token: loginData.token,
        uid: String(loginData.user_id)
      };
      
      request = req.clone({
        setHeaders: headers
      });
    } else {
      request = req.clone({
        setHeaders: {
          cli: 'PAdmon',
        }
      });
    }

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {

        return throwError( err );
      })
    );
  }
} 
